export default __webpack_public_path__ + "static/google-play-de-e27c2f3dde56a0d290cd41f553152a30.png";